import { createFileRoute } from '@tanstack/react-router';

import { LoginScreen } from '../features/auth/LoginScreen';

/**
 * `/login` — اسم مستخدم وكلمة مرور، وهذا كل الدخول اليومي (قرار O-13).
 * المسار رقيق: التركيب في `features/auth`، والشاشة تُعرض **بلا قشرة** لأن
 * `routes/__root.tsx` يستثني هذا المسار من `AppShell` و`CaptureSurface`.
 */
export const Route = createFileRoute('/login')({ component: LoginScreen });
